<template>
	<div>
		<div class="aboutus">

			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span @click="productto(0)" class="aboutitem-hea-text">
						{{product_centet}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in categorylist" >
						<span @click="productto(item.id)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span @click="video_to(0)" class="aboutitem-hea-text">
						{{video_centet.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in video_centet.list" >
						<span @click="video_to(index)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span @click="aboutto(0)" class="aboutitem-hea-text">
						{{about_us.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in about_us.list" >
						<span @click="aboutto(index)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span @click="queryto(-1)" class="aboutitem-hea-text">
						{{contact_us.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in contact_us.list" >
						<span @click="queryto(index)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<div class="aboutus-item">
				<div class="aboutitem-hea">
					<span @click="contactusto(0)" class="aboutitem-hea-text">
						{{follow_us.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in follow_us.list"  >
						<span @click="contactusto(item.id)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="aboutus-item">
				<div class="aboutitem-hea" >
					<div class="contact_box">
						<ul class="phone_num">
							<li class="contact_box_title"><span >服务热线<img src="../assets/pchomeimg/foot_icon/电话.png" alt=""></span></li>
							<li><span>销售部:</span>{{phone_num.sale}}</li>
							<li><span>市场部:</span>{{phone_num.market}}</li>
							<li><span>人力资源部:</span>{{phone_num.humen_resources}}</li>
							<li><span>客户服务部:</span>{{phone_num.customer_service}}</li>
						</ul>
					</div>
<!--					<div class="contact_box">-->
<!--						<ul class="code_icon">-->
<!--							<li class="contact_box_title"><span >邮箱<img src="../assets/pchomeimg/foot_icon/邮箱.png" alt=""></span></li>-->
<!--							<li><span>woodpecker4@glwoodecker.com</span></li>-->
<!--						</ul>-->
<!--					</div>-->
					<div class="contact_box">
						<ul class="code_icon">
							<li class="contact_box_title"><span >关注啄木鸟<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>
							<li v-for="item,index in icon_data" :key="index" class="icon_list">
								<img class="icon" :src="show_code == item.name?item.img_hover:item.img" alt=""
								  @mouseenter="icon_hover(item.name)" @mouseleave="icon_leave">
								<div class="QR_code" :style="show_code == item.name?'opacity:1':'opacity:0'">
									<div class="background"></div>
									<img :src="item.QR_code" alt="">
									<div class="QR_title">
										<div>{{item.text}}</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
<!--				<div class="aboutitem-hea" v-if="$store.state.lang == 'en'">-->
<!--					&lt;!&ndash; <div class="contact_box">-->
<!--						<ul class="address">-->
<!--							<li class="contact_box_title"><span >Address<img src="../assets/pchomeimg/foot_icon/电话.png" alt=""></span></li>-->
<!--							<li><span>Information Industrial Park,Guilin National High-Tech Zone,Guilin,Guangxi,541004 P.R.China</span></li>-->
<!--						</ul>-->
<!--					</div> &ndash;&gt;-->
<!--					&lt;!&ndash; <div class="contact_box_en">-->
<!--						<ul class="code_icon">-->
<!--							<li class="contact_box_title"><span >Address<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>-->
<!--							<li><span>Information Industrial Park,Guilin National High-Tech Zone</span></li>-->
<!--							<li><span>,Guilin,Guangxi,541004 P.R.China</span></li>-->
<!--						</ul>-->
<!--					</div> &ndash;&gt;-->
<!--					<div class="contact_box_en">-->
<!--						<ul class="phone_num">-->
<!--							<li class="contact_box_title"><span >Sales Dept<img src="../assets/pchomeimg/foot_icon/电话.png" alt=""></span></li>-->
<!--							<li><span>+86-773-5873196</span></li>-->
<!--						</ul>-->
<!--					</div>-->
<!--					<div class="contact_box_en">-->
<!--						<ul class="code_icon">-->
<!--							<li class="contact_box_title"><span >E-Mail<img src="../assets/pchomeimg/foot_icon/邮箱.png" alt=""></span></li>-->
<!--							<li><span>woodpecker4@glwoodecker.com</span></li>-->
<!--						</ul>-->
<!--					</div>-->
<!--					&lt;!&ndash; <div class="contact_box_en">-->
<!--						<ul class="code_icon">-->
<!--							<li class="contact_box_title"><span >Address<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>-->
<!--							<li><span>Information Industrial Park,Guilin National High-Tech Zone</span></li>-->
<!--							<li><span>,Guilin,Guangxi,541004 P.R.China</span></li>-->
<!--						</ul>-->
<!--					</div> &ndash;&gt;-->
<!--					<div class="contact_box_en">-->
<!--						<ul class="code_icon">-->
<!--							<li class="contact_box_title"><span >Public Page<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>-->
<!--							<li v-for="(item,index) in icon_data_en" :key="index" class="icon_list">-->
<!--								<img class="icon" :src="show_code == item.name?item.img_hover:item.img" alt=""-->
<!--								  @mouseenter="icon_hover(item.name)" @mouseleave="icon_leave" @click="new_page(item.src)">-->
<!--								  <div class="lang_text">{{item.text}}</div>-->
<!--								&lt;!&ndash; <div class="QR_code" :style="show_code == item.name?'opacity:1':'opacity:0'">-->
<!--									<div class="background"></div>-->
<!--									<img :src="item.QR_code" alt="">-->
<!--									<div class="QR_title">{{item.text}}</div>-->
<!--								</div> &ndash;&gt;-->
<!--							</li>-->
<!--						</ul>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</div>
		<div class="homefoot">
			<div class="foot-hea" >
				copyright@2014桂林市啄木鸟医疗器械有限公司版权所有<a href="https://beian.miit.gov.cn" style="padding: 0 0 0 20px">桂ICP备11001158号-1</a>
			</div>
			<div class="foot-f">
				互联网药品信息服务资格证书（桂）-非经营性-2018-0004
			</div>
		</div>

	</div>

</template>

<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../storage/storage.js';
	export default{
		data(){
			return{
				show_code:'',
				icon_data:[
					{	
						name:'gong_zhong_hao',
						img:require('../assets/pchomeimg/foot_icon/公众号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/公众号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/公众号二维码.png'),
						text:'公众号:啄木鸟医疗'
					},
					{	
						name:'shi_ping_hao',
						img:require('../assets/pchomeimg/foot_icon/视频号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/视频号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/视频号二维码.png'),
						text:'视频号:啄木鸟医疗'
					},
					{	
						name:'xiao_cheng_xu',
						img:require('../assets/pchomeimg/foot_icon/小程序.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/小程序_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信小程序二维码.png'),
						text:'小程序:啄木鸟医疗'
					},
					{	
						name:'wei_bo',
						img:require('../assets/pchomeimg/foot_icon/微博.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微博_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微博二维码.png'),
						text:'微博:啄木鸟医疗'
					},
					{	
						name:'wei_xin',
						img:require('../assets/pchomeimg/foot_icon/微信支付.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微信支付_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信商城二维码.png'),
						text:'商城:啄木鸟配件'
					},
					{	
						name:'WEndo',
						img:require('../assets/pchomeimg/foot_icon/WEendo.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/WEendo_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/WEndo根管公众号二维码.png'),
						text:'公众号:啄木鸟医疗WE根管'
					},
					{	
						name:'tao_bao',
						img:require('../assets/pchomeimg/foot_icon/淘宝.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/淘宝_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/淘宝商城二维码.png'),
						text:'淘宝:啄木鸟医疗'
					}
				],
				icon_data_en:[
					{	
						name:'ins_en',
						img:require('../assets/pchomeimg/foot_icon/ins.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/ins_点击.png'),
						src:'https://www.instagram.com/woodpeckermedical/?hl=zh-cn',
						text:'EN'
					},
					{	
						name:'fb_en',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/WoodpeckerDentalChina',
						text:'EN'
					},
					{	
						name:'fb_es',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/WoodpeckerDentalLatino',
						text:'ES'
					},
					{	
						name:'ins_ar',
						img:require('../assets/pchomeimg/foot_icon/ins.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/ins_点击.png'),
						src:'https://instagram.com/woodpecker_arabic?utm_medium=copy_link',
						text:'AR'
					},
					{	
						name:'fb_ar',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/Woodpecker-Arabic-العربية-106744631679097',
						text:'AR'
					},
					{	
						name:'Youtube',
						img:require('../assets/pchomeimg/foot_icon/Youtube.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/Youtube_点击.png'),
						src:'https://www.youtube.com/channel/UCQR0nx9QqXtsYIidyxYSwxw'
					}
				],
				phone_num:{
					sale:'0773-5831172/5835305',
					market:'0773-2350521',
					humen_resources:'0773-2350520',
					customer_service:'0773-5827898/13978361362'
				},
				categorylist:'',
				channel_data:'',
				product_centet:"产品中心",
				about_us:{
					'title':"关于我们",
					'list' :[
						{'name':"公司简介",'id':1},
						{'name':"公司历史",'id':2},
						{'name':"公司活动相册",'id':3},
						{'name':"公司荣誉",'id':4}
					]
				},
				video_centet:{
					title:'视频中心',
					list:[
						{'name':"产品介绍",'id':1},
						{'name':"案例分析",'id':2},
						{'name':"网络课程",'id':3},
					]
				},
				contact_us:{
					'title':"联系我们",
					'list' :[
						{'name':"维护保养",'id':1},
						{'name':"经销商登入",'id':2},
						{'name':"产品视频",'id':3},
						{'name':"下载专区",'id':4}
					]
				},
				follow_us:{
					'title':"关注我们",
					'list' :[
						{'name':"在线留言",'id':1},
						{'name':"百度地图",'id':2},
					]
				},
				info:{
					'title1':"电话查询",
					'sale':"销售部",
					'marcket':'市场部',
					'humen_resources':"人力资源部",
					'customer_service':"客户服务部",
					'title2':"关注啄木鸟",
				},

			}
		},
		created() {
			this.get_index_channel_data()
			this.get_channel_product_catrgory()
			this.pageParam()
		},
		methods:{
			new_page(src){
				if(src){
					window.open(src)
				}
			},
			icon_hover(item){
				this.show_code = item
			},
			icon_leave(){
				this.show_code = ''
			},
			get_channel_product_catrgory(){
				let data={
					lang:session.get('lang'),
					channel_id: session.get('channel_id'),
          // page:1,
          // pageSize:12,
				}
				this.$api.get_channel_category_list(data).then((res) => {
					this.categorylist=res.data
				});
			},
			get_index_channel_data(){
				return
				let data= {
					mold: "pc",
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				};
				this.$api.get_channel_index(data).then((res) => {
					console.log('res.datafoot')
					this.channel_data =  res.data;
				});
			},
			queryto(index) {
			  	this.$router.push({ path: "/pcquerys?e="+(index*1+1) });
			},
			video_to(index){
				this.$router.push({ path: "/pcvideos?e="+index });
				// if( this.$route.path == '/pcvideos'){
				// 	this.$router.go(0)
				// }
			},
			productto(e) {
				this.$router.push({ path: "/pcproduct?e="+e });
				// if( this.$route.path == '/pcproduct'){
				// 	this.$router.go(0)
				// }
			},
			contactusto(e) {
			  this.$router.push({ path: "/pccontactus",query:{e} });
			},
			aboutto(e) {
			  this.$router.push({ path: "/pcabout?e="+(e*1+1) });
			},
			scrollIntoView(id){
				this.$nextTick(function () {
					var dom = document.getElementById(id)
					if(dom != null){
						dom.scrollIntoView()
					}
				})
			},
			pageParam(){
				this.get_channel_product_catrgory();
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.product_centet = "产品中心",
					this.about_us = {
						'title':"关于我们",
						'list' :[
							{'name':"关于啄木鸟",'id':1},
							{'name':"公司环境",'id':2},
							{'name':"公司荣誉",'id':3},
							{'name':"新闻中心",'id':4}
						]
					},
					this.video_centet={
						title:'视频中心',
						list:[
							{'name':"产品介绍",'id':1},
							{'name':"案例分析",'id':2},
							{'name':"网络课程",'id':3},
						]
					},
					this.contact_us ={
						'title':"用户服务",
						'list' :[
							{'name':"防伪鉴别",'id':1},
							{'name':"维护保养",'id':2},
							{'name':"资料下载",'id':3},
							{'name':"常见问题",'id':4}
						]
					},
					
					this.follow_us = {
						'title':"联系我们",
						'list' :[
							{'name':"在线留言",'id':2},
							{'name':"百度地图",'id':1},
						]
					},
					this.info ={
						'title1':"电话查询",
						'sale':"销售部",
						'marcket':'市场部',
						'humen_resources':"人力资源部",
						'customer_service':"客户服务部",
						'title2':"关注啄木鸟",
					}
				}else{
					this.product_centet = "PRODUCTS",
							this.about_us = {
								'title':"ABOUT US",
								'list' :[
									{'name':"Company Profile",'id':1},
									{'name':"Company History",'id':2},
									{'name':"Company Activity Album",'id':3},
									{'name':"Company Honor",'id':4}
								]
							},
							this.contact_us ={
								'title':"USER SERVICE",
								'list' :[
									{'name':"Anti-Fake Inquiry",'id':1},
									{'name':"Maintenance",'id':2},
									{'name':"Download",'id':3},
									{'name':"FAQ",'id':4}]
							},
							this.video_centet={
								title:'VIDEO',
								list:[
									{'name':"Product Introduction",'id':1},
									{'name':"Case Sharing",'id':2},
									{'name':"Network Course",'id':3},
								]
							},
							this.follow_us = {
								'title':"CONTACT US",
								'list' :[
									{'name':"Online Message",'id':1},
									{'name':"Maps",'id':2},
								]
							},
							this.info={
								'title1':"电话查询",
								'sale':"销售部",
								'marcket':'市场部',
								'humen_resources':"人力资源部",
								'customer_service':"客户服务部",
								'title2':"关注啄木鸟",
							}
				}
			},
			toBeiAn(){
				window.location.href = 'https://beian.miit.gov.cn'
			},
		}
	}
</script>
<style scoped>
li{
	list-style: none;
	position: relative;

}
ul{
	padding:0;
	cursor: auto;
}
.icon{
	width: 30px;
	height: 30px;
}
.icon_list{
	margin-right: 10px;
	position: relative;
	cursor: pointer;
}

.lang_text{
	width: 30px;
	font-size: 12px;
	color: #CCCCCC;
	position: absolute;
	text-align: center;
	left: 0;
	top: 22px;
}
.aboutitem_section{
	position: absolute;
	right: 240px;
}
</style>
<style>
.QR_code{
	width: 172px;
	height: 210px;
	position: absolute;
	left: -70px;
    top: -215px;
	transition: all 0.5s;
}
.QR_title{
	width: 172px;
	position: absolute;
    bottom: 0;
    text-align: center;
	font-size: 12px;
    color: #8a8f99;
	line-height: 1.2;
	display: flex;
	justify-items: center;
	align-content: center;
}
.QR_title div{
	width: 100%;
	height: 40px;
}
.QR_code::after {
    content: '';
    position: absolute;
    top: -webkit-calc(100% - 1px);
    top: -moz-calc(100% - 1px);
    top: calc(100% - 1px);
    left: 50%;
    margin-left: -10px;
    width: 18px;
    height: 11px;
	background-image:url(../assets/pchomeimg/foot_icon/down.svg);
    background-size: 100% 100%;
}
.background{
	width: 172px;
	height: 210px;
	background-color: #FFFFFF;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -0.5;
}
.QR_code img{
	width: 172px;
	height: 172px;
	position: absolute;
}
.contact_box{
	margin-left: 25px;
	font-size: 14px;
	padding-top: 0px;
	/* padding-left: 100px; */
}
.contact_box_en{
	/* margin-left: 1570px; */
	font-size: 14px;
	padding-top: 0px;
	/* padding-left: 100px; */
}
.contact_box_title{
	color: #CCCCCC;
	margin-bottom: 5px;
}
.contact_box_title span{
	position: relative;
}
.contact_box_title img{
	width: 20px;
	height: 20px;
	position: absolute;
	left:-25px;
	top: 0;
}
.code_icon .contact_box_title{
	display: block;
}
.code_icon li{
	display: inline-block;
}
.code_icon span{
	margin-right: 10px;
}


	.aboutus{
		display: flex;
		padding-left: 260px;
		box-sizing: border-box;
		/*height: 670px;*/
		background: #272727;
		/* margin-top: 80px; */
	}
	.aboutus-item{
		width: 150px;
		margin-left: 50px !important;
	}
	.aboutus-item:first-child{
		margin-left: 0px !important;
	}
	.aboutus .aboutus-item:last-child {
		width: 350px;
		margin-left:170px!important;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-hea-text {
		cursor: pointer;
	}
	.aboutitem-foo{
		/*height: 22px;*/
		font-size: 14px;
		font-weight: 400;
		color: #CCCCCC;
		line-height: 22px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
		width: 150px;
		overflow:hidden;
		text-overflow:ellipsis;
		white-space:nowrap;
	}
	.aboutitem-fooitem-text {
		cursor: pointer;
	}
	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{
		
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		margin-top: 18px;
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
	}
	.foot-hea a {
		color: #666666;
		text-decoration:none;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
	}
</style>
